const cache = /* @__PURE__ */ Object.create(null);
function setItem(key, value, useCache) {
  const parsed = JSON.stringify(value);
  localStorage.setItem(key, parsed);
  if (useCache) {
    cache[key] = value;
  }
}
function getItem(key, useCache) {
  if (useCache && cache[key] !== void 0) {
    return cache[key];
  } else {
    try {
      let value = localStorage.getItem(key);
      value = value ? JSON.parse(value) : void 0;
      if (useCache && value !== void 0) {
        cache[key] = value;
      }
      return value;
    } catch (e) {
      localStorage.removeItem(key);
      return null;
    }
  }
}
function removeItem(key) {
  localStorage.removeItem(key);
  delete cache[key];
}
export {
  getItem,
  removeItem,
  setItem
};
//# sourceMappingURL=index.es.js.map
